import React from 'react'
import { useSelector } from 'react-redux'
import Slider from '../slides/Slider'
import { useNavigate } from 'react-router-dom'

const CurrentPlaylist = (props) => {

    const {user} = useSelector(state=>state.user)

    const navigate = useNavigate()

    const { playlistVideos, active_pl_title, active_pl_id, playlist_user_id } = useSelector(state => state.userPlaylists)


    const viewAllHandler = () => {
        if(user ){
            if (user.id === playlist_user_id) {
                navigate(encodeURI(`/myPlaylist/${active_pl_id}/${active_pl_title}`))
            } else {
                navigate(encodeURI(`/playlist/${active_pl_id}/${active_pl_title}`))
            }
        } else {
            navigate('/login')
        }
      }

    return (
        <>

            <div className="col-12" style = {{ marginBottom:"2.5vw"}}>
                {
                    playlistVideos && playlistVideos.length ? 
                    <Slider
                        num = {6}
                        type = {4}
                        showTitle = {true}
                        tvData={playlistVideos}
                        slideClickHandler={props.videoClickHandler}
                        slideTitle = {active_pl_title}
                        showAllHandler = {viewAllHandler}
                    /> : ''
                }  
            </div>
                
        </>
    );
};

export default CurrentPlaylist;